import React from 'react';
import { Section, Title } from '../components';
import { profileData } from '../data';
import may17th from './../assets/images/may17th.jpg';

const About = () => {
  return (
    <Section id="about">
      <Title as="h2">About me</Title>

      <div className="flex flex-col-reverse items-start justify-start gap-7 lg:flex-row lg:items-stretch">
        <div className="w-auto h-auto">
          <img
            className="object-cover w-full h-full overflow-hidden shadow-xl bg-foreground-accent rounded-3xl ring-1 ring-black"
            src={may17th}
            alt="Danny Thinh Tran"
          />
        </div>
        <div className="flex flex-col w-auto gap-1 h-fit text-midground">
          <Title as="h4" className="mb-2 font-semibold">
            Alright, let&#39;s do this one last time.
          </Title>
          <div className="flex flex-col gap-3 leading-relaxed">
            {profileData.profile.about.map((paragraph, index) => (
              <div key={index}>{paragraph}</div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default About;
